webpackJsonp([1],{

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AWOg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DN8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02796314","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("oXGk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4815840","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("NqUU")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2d63fc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("jsA2")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-b2d63fc6"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d48a67d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("DN8u")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-6d48a67d"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var NavigationBar = ({
  props: ['logoURL', 'title', 'page', 'companyName', 'width'],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['zoomEnabled', 'contentsEnabled', 'searchEnabled', 'languagesEnabled', 'downloadEnabled', 'printEnabled', 'rightToLeft', 'companyLogo', 'downloadPath', 'showContents', 'showLanguages', 'showSearch', 'isZoomed']), {
    divider: function divider() {
      if (this.rightToLeft) return 'chevron-left';
      return 'chevron-right';
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleLanguages: 'TOGGLE_LANGUAGES',
    toggleZoom: 'TOGGLE_ZOOM',
    toggleSearch: 'TOGGLE_SEARCH'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e3e1e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(_vm.zoomEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()])])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("XSu0")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79eb1399","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("uCte")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ContentsPanel = ({
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    getBackgroundURL: function getBackgroundURL(index) {
      return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
    }

  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80aebe88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('li',{key:index,staticClass:"contents-item",class:{active: page[0].pageIndex == _vm.currentPage.pageIndex},on:{"click":function($event){_vm.goToPage({pageIndex: index + 1, sectionIndex: 1})}}},[_c('div',{staticClass:"contents-item__text"},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(page[0].title))])]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(index)})})])}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("Q7Iq")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36934d9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("UxE6")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3df2afbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)])])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("gmqq")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "basePath", "galleryIndex"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f1f43fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1),_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("Nf/c")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-3f1f43fe"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages'])),
  mounted: function mounted() {
    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1c27de4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e(),_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("AWOg")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';

var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "6 OF THE BEST - Châteaus in France",
  "shortTitle": "",
  "description": "",
  "width": 1200,
  "height": 848,
  "currentLanguage": "EN",
  "languages": [],
  "basePath": "/6ofthebest/chateaus",
  "companyLogo": "1-logo.png",
  "publishURL": "https://publish.ironstone.ltd/6ofthebest/chateaus/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": false,
    "mobileSwitch": false
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      <img style=\"position:absolute; top: 38px; left: 385px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/1-t1.png\" id=\"1-title\">\n      <img style=\"position:absolute; top: 172px;left: 353px;;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/1-t2.png\" id=\"1-sub-1\">\n\n      <img style=\"position:absolute; top: 731px; left: 1034px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/1-logo.png\" id=\"1-logo\" >\n\n      <div class=\"addContentLink\" style=\"bottom: 29px;\n      left: 1030px;\n      width: 143px;\n      height: 91px;\">\n        <a href=\"http://www.sotb.online/\" target=\"_blank\"></a></div>\n\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(idOf(\"1-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"1-sub-1\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(idOf(\"1-logo\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "OF THE BEST CHÂTEAUS IN FRANCE  SIX OF THE BEST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n      <img style=\"position:absolute; top: 38px;\n      left: 451px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/2-t1.png\" id=\"2-title\">\n\n\n\n      \n\n      <div id=\"2-sig\" class=\"abs noOverflow\" style=\"top:598px;left:674px;height:63px;width:123px\">\n          <img class=\"halfScale\" src=\"/6ofthebest/chateaus/static/_content/2-sig.png\">\n        </div>\n\n\n      <img style=\"position:absolute; top: 710px;\n      left: 680px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/2-logo.png\" id=\"2-logo\" >\n\n      <img style=\"position:absolute; top: 432px;\n      left: 340px;display: none;\"  class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/2-bal.jpg\" id=\"2-bal\">\n<img style=\"position:absolute; top: 459px;\nleft: 290px;\" onclick=\"pin1Open()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/castle.png\" id=\"2-bal\">\n\n      <img style=\"position:absolute; top: 420px;\n      left: 6px;display: none;\"  class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/2-bas.jpg\" id=\"2-bas\">\n<img style=\"position:absolute; top: 442px;\nleft: 233px;\" onclick=\"pin2Open()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/castle.png\" id=\"2-bas\">\n\n      <img style=\"position:absolute; top: 515px;\n      left: 391px;display: none;\"  class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/2-rib.jpg\" id=\"2-rib\">\n<img style=\"position:absolute; top: 540px;\nleft: 341px;\" onclick=\"pin3Open()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/castle.png\" id=\"2-rib\">\n\n      <img style=\"position:absolute; top: 263px;\n      left: 384px;display: none;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/2-lys.jpg\" id=\"2-lys\">\n<img style=\"position:absolute; top: 283px;\nleft: 332px;\" onclick=\"pin4Open()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/castle.png\" id=\"2-lys\">\n\n      <img style=\"position:absolute; top: 497px;\n      left: 29px;display: none;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/2-ten.jpg\" id=\"2-ten\">\n <img style=\"position:absolute; top: 521px;\nleft: 257px;\" onclick=\"pin5Open()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/castle.png\" id=\"2-ten\">\n\n      <img style=\"position:absolute; top: 329px;\n      left: 259px;display: none;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/2-norm.jpg\" id=\"2-norm\">\n<img style=\"position:absolute; top: 352px;\nleft: 209px;\" onclick=\"pin6Open()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/castle.png\" id=\"2-norm\">\n\n<div class=\"addContentLink\" style=\"top: 420px; left: 6px; width: 223px; height: 90px;\" onclick=\"Publish.goToPage(3)\"></div>\n\n<div class=\"addContentLink\" style=\"top: 263px; left: 384px; width: 223px; height: 90px;\" onclick=\"Publish.goToPage(5)\"></div>\n\n<div class=\"addContentLink\" style=\"top: 432px; left: 340px; width: 223px; height: 90px;\" onclick=\"Publish.goToPage(7)\"></div>\n\n<div class=\"addContentLink\" style=\"top: 497px; left: 29px; width: 223px; height: 90px;\" onclick=\"Publish.goToPage(9)\"></div>\n\n<div class=\"addContentLink\" style=\"top: 329px; left: 259px; width: 223px; height: 90px;\" onclick=\"Publish.goToPage(11)\"></div>\n\n<div class=\"addContentLink\" style=\"top: 515px;left: 391px; width: 223px; height: 90px;\" onclick=\"Publish.goToPage(13)\"></div>\n\n      <div class=\"addContentLink\" style=\"bottom: 270px;left: 835px;width: 231px;height: 16px;\">\n        <a href=\"http://www.channel4.com/programmes/escape-to-the-chateau-diy\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLink\" style=\"bottom: 49px;\n        left: 678px;\n        width: 151px;\n        height: 97px;\">\n          <a href=\"http://www.sotb.online/\" target=\"_blank\"></a></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim.fromTo(idOf(\"2-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"2-sig\"), 0.6, {width:\"0px\"}, {width:\"123px\", ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(idOf(\"2-logo\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          removeContentLinks();\n        }\n\nfunction pin1Open() {\n   var x = document.getElementById(\"2-bal\");\n   if (x.style.display === \"none\") {\n       x.style.display = \"block\";\n       document.getElementById(\"2-bas\").style.display  = \"none\";\n       document.getElementById(\"2-rib\").style.display  = \"none\";\n       document.getElementById(\"2-lys\").style.display  = \"none\";\n       document.getElementById(\"2-ten\").style.display  = \"none\";\n       document.getElementById(\"2-norm\").style.display  = \"none\";\n   } else {\n       x.style.display = \"none\";\n   }\n}\n\nfunction pin2Open() {\n   var x = document.getElementById(\"2-bas\");\n   if (x.style.display === \"none\") {\n       x.style.display = \"block\";\n       document.getElementById(\"2-bal\").style.display  = \"none\";\n       document.getElementById(\"2-rib\").style.display  = \"none\";\n       document.getElementById(\"2-lys\").style.display  = \"none\";\n       document.getElementById(\"2-ten\").style.display  = \"none\";\n       document.getElementById(\"2-norm\").style.display  = \"none\";\n   } else {\n       x.style.display = \"none\";\n   }\n}\n\nfunction pin3Open() {\n   var x = document.getElementById(\"2-rib\");\n   if (x.style.display === \"none\") {\n       x.style.display = \"block\";\n       document.getElementById(\"2-bal\").style.display  = \"none\";\n       document.getElementById(\"2-bas\").style.display  = \"none\";\n       document.getElementById(\"2-lys\").style.display  = \"none\";\n       document.getElementById(\"2-ten\").style.display  = \"none\";\n       document.getElementById(\"2-norm\").style.display  = \"none\";\n   } else {\n       x.style.display = \"none\";\n   }\n}\n\nfunction pin4Open() {\n   var x = document.getElementById(\"2-lys\");\n   if (x.style.display === \"none\") {\n       x.style.display = \"block\";\n       document.getElementById(\"2-bal\").style.display  = \"none\";\n       document.getElementById(\"2-bas\").style.display  = \"none\";\n       document.getElementById(\"2-rib\").style.display  = \"none\";\n       document.getElementById(\"2-ten\").style.display  = \"none\";\n       document.getElementById(\"2-norm\").style.display  = \"none\";\n   } else {\n       x.style.display = \"none\";\n   }\n}\n\nfunction pin5Open() {\n   var x = document.getElementById(\"2-ten\");\n   if (x.style.display === \"none\") {\n       x.style.display = \"block\";\n       document.getElementById(\"2-bal\").style.display  = \"none\";\n       document.getElementById(\"2-bas\").style.display  = \"none\";\n       document.getElementById(\"2-rib\").style.display  = \"none\";\n       document.getElementById(\"2-lys\").style.display  = \"none\";\n       document.getElementById(\"2-norm\").style.display  = \"none\";\n   } else {\n       x.style.display = \"none\";\n   }\n}\n\nfunction pin6Open() {\n   var x = document.getElementById(\"2-norm\");\n   if (x.style.display === \"none\") {\n       x.style.display = \"block\";\n       document.getElementById(\"2-bal\").style.display  = \"none\";\n       document.getElementById(\"2-bas\").style.display  = \"none\";\n       document.getElementById(\"2-rib\").style.display  = \"none\";\n       document.getElementById(\"2-lys\").style.display  = \"none\";\n       document.getElementById(\"2-ten\").style.display  = \"none\";\n   } else {\n       x.style.display = \"none\";\n   }\n}\n\n      ",
    "searchText": "CONTENTS Click the Château icons to visit the Château page or hover to find out more  Welcome to Château Escapes, from Six of The Best Online Our Team have hand-picked six of their favourite Châteaus with English speaking owners that France has to offer. These carefully selected Châteaus are situated throughout France and give you access to a wide range of activities, beautiful gardens and historic grounds to help you enjoy your French break. The Château’s vary and offer tennis courts, private chapels, romantic walled gardens and stunning views suitable for Weddings, Aniversaries, Romantic breaks, and Family holidays. Whichever Château you chose to stay in they all offer an excellent base to explore the fantastic, historic French countryside. If you wish to get to know the owners a little better, many of the Château’s have recently featured on Channel 4’s Escape to the Château.  On Behalf of Six of the best online"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n\n      <img style=\"position:absolute; top: 730px;\n      left: 140px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/3-text.png\" id=\"3-text\" >\n\n      <img style=\"position:absolute; top: 0px;\n      right: 35px; display: none; z-index:2;\" class=\"1-title\" src=\"/6ofthebest/chateaus/static/_content/3-contact.jpg\" id=\"3-btn-text\">\n\n      <div class=\"addContentLink\" style=\"bottom: 722px; left: 947px; width: 128px; height: 21px; z-index:3\">\n        <a href=\"http://www.basmaignee.com\" target=\"_blank\"></a></div>\n\n      <img style=\"position:absolute; top: 48px;\n      left: 309px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/3-t1.png\" id=\"3-title\">\n\n      <img style=\"position:absolute; top: 0px;\n      right: -35px;\" onclick=\"threeSlide()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/3-btn.jpg\" id=\"3-contact\">\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n          pg3Anim.fromTo(idOf(\"3-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"3-text\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.4\")\n        }\n\n        function threeSlide() {\n          var x = document.getElementById(\"3-btn-text\");\n          if (x.style.display === \"none\" ) {\n              x.style.display = \"block\";\n              \n          } else {\n              x.style.display = \"none\";\n          }\n       }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n          removeContentLinks();\n        }\n\n        \n      ",
    "searchText": "The château sits in over 60 acres of parkland, which contains a private chapel, a traditional walled garden, six cottages, and 25 acres of forest with a secluded lake. Facilities include tennis court, woodland walks, local wildlife spotting, and much more.​  phone  Château de la Basmaignée is located in the Mayenne area, North West of France, close to the historic village of Montenay. With its rich history of Royalty and Nobility, France is home to countless châteaux, and the Pays de la Loire region holds many of them.  Contact  Château de la Basmaignée"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.png",
    "zoom": null,
    "content": "\n      <img style=\"position:absolute; top: 664px;\n      left: 264px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/4-url.png\" id=\"4-url\">\n      <div class=\"addContentLink\" style=\"bottom: 114px;\n      left: 262px;\n      width: 660px;\n      height: 71px;\n      \">\n        <a href=\"http://www.basmaignee.com\" target=\"_blank\"></a></div>\n\n      <img style=\"position:absolute; top: 140px;\n      left: 157px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/4-img1.png\" id=\"4-img1\">\n      <img style=\"position:absolute; top: 346px;\n      left: 98px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/4-img2.png\" id=\"4-img2\">\n      <img style=\"position:absolute; top: 309px;\n      left: 330px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/4-img3.png\" id=\"4-img3\">\n      <img style=\"position:absolute; top: 120px;\n      left: 451px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/4-img4.png\" id=\"4-img4\">\n      <img style=\"position:absolute; top: 305px;\n      left: 548px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/4-img5.png\" id=\"4-img5\">\n      <img style=\"position:absolute; top: 93px;\n      left: 723px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/4-img6.png\" id=\"4-img6\">\n      <img style=\"position:absolute; top: 353px;\n      left: 783px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/4-img7.png\" id=\"4-img7\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(idOf(\"4-url\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"4-img1\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"4-img2\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"4-img3\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"4-img4\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"4-img5\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"4-img6\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"4-img7\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "WWW.BASMAIGNEE.COM"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n\n      <img style=\"position:absolute; top: 90px;\n      left: 427px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/5-t1.png\" id=\"5-title\">\n\n      <img style=\"position:absolute; top: 48px;\n      left: 750px; display: none;\" class=\"1-title\" src=\"/6ofthebest/chateaus/static/_content/5-contact.jpg\" id=\"5-btn-text\">\n\n      <div class=\"addContentLink\" style=\"bottom: 671px; left: 902px; width: 128px; height: 21px;\n      \">\n\n\n        <a href=\"http://www.chateaudeslys.nl\" target=\"_blank\"></a></div>\n\n      \n      <img style=\"position:absolute; top: 706px;\n      left: 118px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/5-text.png\" id=\"5-text\">\n\n      <img style=\"position:absolute; top: 48px;\n      right: 17px;\" onclick=\"fiveSlide()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/5-btn.jpg\" id=\"5-contact\">\n\n      <div class=\"addContentLink\" style=\"bottom: 126px;\n      left: 226px;\n      width: 273px;\n      height: 16px;\">\n        <a href=\"http://www.channel4.com/programmes/escape-to-the-chateau-diy\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLink\" style=\"bottom: 89px;\n        left: 769px;\n        width: 122px;\n        height: 16px;\">\n          <a href=\"http://www.chateauweddings.eu\" target=\"_blank\"></a></div>\n\n          <div class=\"addContentLink\" style=\"bottom: 70px;\n          left: 360px;\n          width: 191px;height: 16px;\">\n            <a href=\"http://mychateau.one/\" target=\"_blank\"></a></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n          pg5Anim.fromTo(idOf(\"5-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"5-text\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop();\n          removeContentLinks();\n        }\n\n        function fiveSlide() {\n          var x = document.getElementById(\"5-btn-text\");\n          if (x.style.display === \"none\" ) {\n              x.style.display = \"block\";\n              \n          } else {\n              x.style.display = \"none\";\n          }\n       }\n      ",
    "searchText": "phone  As seen in the Channel 4 series Escape to the Château DIY, the Château des Lys is a 19th century ex-hunting lodge overlooks the picturesque Somme Estuary; and is only 1 hour south of Calais. Whether you’re planning an intimate informal gathering, a vintage bohemian country wedding, or that no holds barred party to end all parties, the Château des Lys is the perfect location. The owners offer a range of Wedding packages to suit you and your budget. They are also selling affordable co- housing shares in a couple of Gites fashioned from the old Chateau des Lys smithy.  Contact  Château des Lys"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n      <img style=\"position:absolute; top: 664px;\n      left: 195px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/6-url.png\" id=\"6-url\">\n      <div class=\"addContentLink\" style=\"bottom: 114px;\n      left: 192px;\nwidth: 799px;\n      height: 71px;\n      \">\n        <a href=\"http://www.chateauweddings.eu\" target=\"_blank\"></a></div>\n\n      <img style=\"position:absolute; top: 140px;\n      left: 157px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/6-img1.png\" id=\"6-img1\">\n      <img style=\"position:absolute; top: 346px;\n      left: 98px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/6-img2.png\" id=\"6-img2\">\n      <img style=\"position:absolute; top: 309px;\n      left: 330px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/6-img3.png\" id=\"6-img3\">\n      <img style=\"position:absolute; top: 120px;\n      left: 451px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/6-img4.png\" id=\"6-img4\">\n      <img style=\"position:absolute; top: 305px;\n      left: 548px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/6-img5.png\" id=\"6-img5\">\n      <img style=\"position:absolute; top: 93px;\n      left: 723px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/6-img6.png\"  id=\"6-img6\">\n      <img style=\"position:absolute; top: 353px;\n      left: 783px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/6-img7.png\" id=\"6-img7\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.fromTo(idOf(\"6-url\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"6-img1\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"6-img2\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"6-img3\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"6-img4\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"6-img5\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"6-img6\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"6-img7\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "WWW.CHATEAUWEDDINGS.EU"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n\n      <img style=\"position:absolute; top: 46px;\n      left: 387px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/7-t1.png\" id=\"7-title\" >\n\n      <img style=\"position:absolute; top: 0px;\n      left: 791px; display: none;\" class=\"1-title\" src=\"/6ofthebest/chateaus/static/_content/7-contact.jpg\" id=\"7-btn-text\" >\n\n      <div class=\"addContentLink\" style=\"bottom: 714px; left: 948px; width: 168px; height: 21px;\">\n        <a href=\"http://www.chateaudubailleul.com\" target=\"_blank\"></a></div>\n\n      <img style=\"position:absolute; top: 696px;\n      left: 153px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/7-text.png\" id=\"7-text\">\n\n      <img style=\"position:absolute; top: 0px;\n      right: -35px;\" onclick=\"sevenSlide()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/7-btn.jpg\" id=\"7-contact\">\n\n\n      <div class=\"addContentLink\" style=\"bottom: 137px;\n      left: 698px;\n      width: 178px;\n      height: 16px;\">\n        <a href=\"http://www.channel4.com/programmes/escape-to-the-chateau-diy\" target=\"_blank\"></a></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.fromTo(idOf(\"7-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"7-text\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop();\n          removeContentLinks();\n        }\n\n        function sevenSlide() {\n          var x = document.getElementById(\"7-btn-text\");\n          if (x.style.display === \"none\" ) {\n              x.style.display = \"block\";\n              \n          } else {\n              x.style.display = \"none\";\n          }\n       }\n\n      ",
    "searchText": "At Château Du Bailleul we offer informal home stays where you can explore what this fantastic area has to offer, experience the reality of life in a Château with us or simply relax on the terrace with a glass of wine. We can supply the venue as a blank canvas or provide all the help and assistance to make your special day dreams come true.  phone  Château Du Bailleul is an 18th Century French Château in Pays De La Loire, featured on ‘Escape to the Château: DIY’, available as a wedding and event venue to suit all budgets, filming location, homestay accommodation and volunteering projects.  Contact  Château du Bailleul"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.png",
    "zoom": null,
    "content": "\n      <img style=\"position:absolute; top: 664px;\n      left: 158px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/8-url.png\" id=\"8-url\">\n      <div class=\"addContentLink\" style=\"bottom: 114px;\n      left: 156px;\n      width: 889px;\n      height: 71px;\n      \">\n        <a href=\"http://www.chateaudubailleul.com\" target=\"_blank\"></a></div>\n\n      <img style=\"position:absolute; top: 140px;\n      left: 157px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/8-img1.png\" id=\"8-img1\">\n      <img style=\"position:absolute; top: 346px;\n      left: 98px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/8-img2.png\" id=\"8-img2\">\n      <img style=\"position:absolute; top: 120px;\n      left: 451px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/8-img4.png\" id=\"8-img3\">\n      <img style=\"position:absolute; top: 305px;\n      left: 548px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/8-img5.png\" id=\"8-img4\">\n      <img style=\"position:absolute; top: 93px;\n      left: 723px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/8-img6.png\" id=\"8-img5\">\n      <img style=\"position:absolute; top: 353px;\n      left: 783px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/8-img7.png\" id=\"8-img6\">\n      <img style=\"position:absolute; top: 309px;\n      left: 330px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/8-img3.png\" id=\"8-img7\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.fromTo(idOf(\"8-url\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"8-img1\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"8-img2\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"8-img3\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"8-img4\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"8-img5\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"8-img6\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"8-img7\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "WWW.CHATEAUDUBAILLEUL.COM"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n      <img style=\"position:absolute; top: 86px;\n      left: 357px; \" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/9-t1.png\" id=\"9-title\">\n\n      <img style=\"position:absolute; top: 48px;\n      left: 750px; display: none;\" class=\"1-title\" src=\"/6ofthebest/chateaus/static/_content/9-contact.jpg\" id=\"9-btn-text\">\n\n      <div class=\"addContentLink\" style=\"bottom: 686px; left: 889px; width: 98px; height: 21px;\">\n        <a href=\"http://www.tennessus.com\" target=\"_blank\"></a></div>\n\n      <img style=\"position:absolute; top: 701px;\n      left: 136px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/9-text.png\" id=\"9-text\">\n\n      <img style=\"position:absolute; top: 48px;\n      right: 17px;\" onclick=\"nineSlide()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/9-btn.png\" id=\"9-contact\">\n\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim.fromTo(idOf(\"9-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"9-text\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop();\n          removeContentLinks();\n        }\n\n        function nineSlide() {\n          var x = document.getElementById(\"9-btn-text\");\n          if (x.style.display === \"none\" ) {\n              x.style.display = \"block\";\n              \n          } else {\n              x.style.display = \"none\";\n          }\n       }\n\n      ",
    "searchText": "phone  Set in the heart of historic Poitou and entirely surrounded by water, Château de Tennessus is a stunning, fully restored, medieval castle B&B where time stands still, and only the plumbing is comfortingly modern. Built over 600 years ago (supposedly to keep out the English!) and dominated by an imposing rectangular keep (housing three enormous B&B rooms), Tennessus castle is totally authentic, with original stone spiral staircases, arrow slits, hoardings, bare stone walls and a working drawbridge!  Contact  Château de Tennessus"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.png",
    "zoom": null,
    "content": "\n      <img style=\"position:absolute; top: 679px;\n      left: 293px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/10-url.png\" id=\"10-url\">\n      <div class=\"addContentLink\" style=\"bottom: 100px;\n      left: 289px;\n      width: 629px;\n      height: 71px;\n      \">\n        <a href=\"http://www.tennessus.com\" target=\"_blank\"></a></div>\n\n      <img style=\"position:absolute; top: 150px;\n      left: 157px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/10-img1.png\" id=\"10-img1\">\n      <img style=\"position:absolute; top: 356px;\n      left: 98px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/10-img2.png\" id=\"10-img2\">\n      <img style=\"position:absolute; top: 319px;\n      left: 330px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/10-img3.png\" id=\"10-img3\">\n      <img style=\"position:absolute; top: 130px;\n      left: 451px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/10-img4.png\" id=\"10-img4\">\n      <img style=\"position:absolute; top: 315px;\n      left: 548px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/10-img5.png\" id=\"10-img5\">\n      <img style=\"position:absolute; top: 103px;\n      left: 723px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/10-img6.png\" id=\"10-img6\">\n      <img style=\"position:absolute; top: 363px;\n      left: 783px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/10-img7.png\" id=\"10-img7\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim.fromTo(idOf(\"10-url\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"10-img1\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"10-img2\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"10-img3\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"10-img4\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"10-img5\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"10-img6\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"10-img7\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "WWW.TENNESSUS.COM"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n\n      <img style=\"position:absolute; top: 92px;\n      left: 382px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/11-t1.png\" id=\"11-title\">\n\n      <img style=\"position:absolute; top: 48px;\n      left: 739px; display: none;\" class=\"1-title\" src=\"/6ofthebest/chateaus/static/_content/11-contact.jpg\" id=\"11-btn-text\">\n\n      <div class=\"addContentLink\" style=\"bottom: 677px;left: 896px; width: 178px; height: 21px; \">\n        <a href=\"http://www.le-castel-normandy.com\" target=\"_blank\"></a></div>\n\n      <img style=\"position:absolute; top: 707px;\n      left: 157px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/11-text.png\" id=\"11-text\">\n\n      <img style=\"position:absolute; top: 48px;\n      right: 17px;\" onclick=\"elevenSlide()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/11-btn.jpg\" id=\"11-contact\">\n\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim.fromTo(idOf(\"11-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"11-text\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n          removeContentLinks();\n        }\n\n        function elevenSlide() {\n          var x = document.getElementById(\"11-btn-text\");\n          if (x.style.display === \"none\" ) {\n              x.style.display = \"block\";\n              \n          } else {\n              x.style.display = \"none\";\n          }\n       }\n\n      ",
    "searchText": "phone  Le Castel is a classic Napoleon III Château in Normandy offering Bed and Breakfast plus some rather special family holidays in school breaks. We specialise in all-inclusive family holidays in July and August, but at other times we are a normal Chambre d’Hotes (guest house) for adults, which is a friendlier and more relaxed environment than a hotel. Le Castel is luxurious for adults, whilst fun for kids.  Contact  Le Castel Normandy"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.png",
    "zoom": null,
    "content": "\n      <img style=\"position:absolute; top: 665px;\n      left: 210px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/12-url.png\" id=\"12-url\">\n      <div class=\"addContentLink\" style=\"bottom: 115px;\n      left: 203px;\n      width: 779px;\n      height: 71px;\n      \">\n        <a href=\"http://www.le-castel-normandy.com\" target=\"_blank\"></a></div>\n\n      <img style=\"position:absolute; top: 150px;\n      left: 157px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/12-img1.png\" id=\"12-img1\">\n      <img style=\"position:absolute; top: 356px;\n      left: 98px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/12-img2.png\" id=\"12-img2\">\n      <img style=\"position:absolute; top: 319px;\n      left: 330px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/12-img3.png\" id=\"12-img3\">\n      <img style=\"position:absolute; top: 130px;\n      left: 451px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/12-img4.png\" id=\"12-img4\">\n      <img style=\"position:absolute; top: 315px;\n      left: 548px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/12-img5.png\" id=\"12-img5\">\n      <img style=\"position:absolute; top: 103px;\n      left: 723px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/12-img6.png\" id=\"12-img6\">\n      <img style=\"position:absolute; top: 363px;\n      left: 783px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/12-img7.png\" id=\"12-img7\">\n      ",
    "script": "\n        function onPageEnter() {\n            pg12Anim = new TimelineMax();\n            pg12Anim.fromTo(idOf(\"12-url\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n            .fromTo(idOf(\"12-img1\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"12-img2\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"12-img3\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"12-img4\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"12-img5\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"12-img6\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"12-img7\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "LE-CASTEL-NORMANDY.COM"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n\n      <img style=\"position:absolute; top: 90px;\n      left: 402px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/13-t1.png\" id=\"13-title\">\n\n      <img style=\"position:absolute; top: 48px;\n      left: 738px; display: none;\" class=\"1-title\" src=\"/6ofthebest/chateaus/static/_content/13-contact.jpg\" id=\"13-btn-text\">\n      <div class=\"addContentLink\" style=\"bottom: 667px; left: 896px; width: 158px; height: 21px;\">\n        <a href=\"http://www.chateauribagnac.com\" target=\"_blank\"></a></div>\n\n      <img style=\"position:absolute; top: 724px;\n      left: 136px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/13-text.png\" id=\"13-text\">\n\n      <img style=\"position:absolute; top: 48px;\n      right: 17px;\" onclick=\"thirteenSlide()\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/13-btn.png\" id=\"13-contact\">\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim.fromTo(idOf(\"13-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"13-text\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.4\")\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop();\n          removeContentLinks();\n        }\n\n        function thirteenSlide() {\n          var x = document.getElementById(\"13-btn-text\");\n          if (x.style.display === \"none\" ) {\n              x.style.display = \"block\";\n              \n          } else {\n              x.style.display = \"none\";\n          }\n       }\n\n      ",
    "searchText": "phone  Château Ribagnac is more than a romantic castle that has been lovingly converted into chambres d’hôtes; it is a breathtaking country retreat. Built in around 1560, the Château has accumulated character and style over the ages. It perfectly combines the charm and atmosphere of the old with the comfort and convenience of the modern. The Château is situated in its own grounds with stunning views across the valley.  Contact  Château Ribagnac"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n      <img style=\"position:absolute; top: 665px;\n      left: 179px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/14-url.png\" id=\"14-url\">\n      <div class=\"addContentLink\" style=\"bottom: 115px;left: 176px;width: 830px;      height: 71px;\n      \">\n        <a href=\"http://www.chateauribagnac.com\" target=\"_blank\"></a></div>\n\n      <img style=\"position:absolute; top: 150px;\n      left: 157px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/14-img1.png\" id=\"14-img1\">\n      <img style=\"position:absolute; top: 356px;\n      left: 98px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/14-img2.png\" id=\"14-img2\">\n      <img style=\"position:absolute; top: 319px;\n      left: 330px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/14-img3.png\" id=\"14-img3\">\n      <img style=\"position:absolute; top: 130px;\n      left: 451px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/14-img4.png\" id=\"14-img4\">\n      <img style=\"position:absolute; top: 315px;\n      left: 548px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/14-img5.png\" id=\"14-img5\">\n      <img style=\"position:absolute; top: 103px;\n      left: 723px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/14-img6.png\" id=\"14-img6\">\n      <img style=\"position:absolute; top: 363px;\n      left: 783px;\" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/14-img7.png\" id=\"14-img7\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n            pg14Anim.fromTo(idOf(\"14-url\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n            .fromTo(idOf(\"14-img1\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"14-img2\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"14-img3\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"14-img4\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"14-img5\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"14-img6\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"14-img7\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "WWW.CHATEAURIBAGNAC.COM"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n      <img style=\"position:absolute; top: 64px;\n      left: 252px;\n      \" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/15-t1.png\" id=\"15-title\">\n\n      <img style=\"position:absolute; top: 366px;\n      left: 78px;\n      \" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/15-img1.jpg\" id=\"15-img1\">\n      <img style=\"position:absolute; top: 356px;\n      left: 453px;\n      \" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/15-img2.png\" id=\"15-img2\">\n      <img style=\"position:absolute; top: 382px;\n      left: 816px;\n      \" class=\"1-title halfScale\" src=\"/6ofthebest/chateaus/static/_content/15-img3.png\" id=\"15-img3\">\n\n      <div class=\"addContentLink\" style=\"bottom: 90px;\n      left: 474px;\n      width: 250px;\n      height: 41px;\n      \">\n        <a href=\"http://www.sotb.online/\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLink\" style=\"bottom: 35px;\n        left: 436px;\n        width: 330px;\n        height: 41px;\n        \">\n          <a href=\"http://www.ironstone.ltd\" target=\"_blank\"></a></div>\n      ",
    "script": "\n        function onPageEnter() {\n           pg15Anim = new TimelineMax();\n            pg15Anim.fromTo(idOf(\"15-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n            .fromTo(idOf(\"15-img1\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"15-img2\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n            .fromTo(idOf(\"15-img3\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Six Of The Best is presented to you by Ironstone Software LTD SIX OF THE BEST  We are a software development company based in Northamptonshire. We design and build websites, digital magazines and bespoke software tailored to you, to bring the best out of your business. There are two things we want you to know - we treat every job like its our first and we will help in any way we can.  WWW.SOTB.ONLINE WWW.IRONSTONE.LTD"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var thisPage = document.querySelector('.currentPage') \n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var thisPage = document.querySelector('.currentPage') \n        var contentLinks = [].slice.call(thisPage.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js




/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        router.push(context.getters.routeFromIndex(payload, 1), function () {
          // console.log(payload)
          context.commit('CHANGE_SECTION_INDEX', {
            pageIndex: payload,
            sectionIndex: 0
          });
        });
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
          // console.log(payload)
          context.commit('CHANGE_SECTION_INDEX', {
            pageIndex: payload.pageIndex - 1,
            sectionIndex: payload.sectionIndex - 1
          });
        });
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      context.commit('UPDATE_PAGE_SCALE', { pageScale: 1 });
    } else {
      var newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == 'Contents';
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == 'Languages';
  },
  showSearch: function showSearch(state) {
    return state.activePanel == 'Search';
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + '/static/_content/' + state.document.companyLogo;
    } else return getters.basePath + '/static/kp-logo-white.svg';
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return '/' + pageIndex + '-' + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          currentPage: getters.currentPage,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          leftPage: null,
          currentPage: getters.currentPage,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[getters.pageIndex - 4]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[getters.pageIndex - 3]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[getters.pageIndex - 2]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[getters.pageIndex]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[getters.pageIndex + 1]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[getters.pageIndex + 2]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) return getters.routeFromIndex(Math.ceil(getters.pageIndex - 2), 1);
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null) return null;
    if (state.isDoublePage && getters.doublePage) return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: 'scale(' + getters.pageContainerZoomLevel * state.pageScale + ')'
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + 'px ' + state.zoomOriginY + 'px';
    } else {
      styleObject.transformOrigin = '0px 0px';
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + '-' + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join('\n');
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return '/' + (pageLink.index + 1) + '-' + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },
  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage 


  //#endregion

});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  if (state.zoomLevel < 1) state.zoomLevel = 1;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: true,
    galleryImages: []
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;

    var hammertime = new hammer_default.a(document.getElementById("app"), {
      touchAction: "auto"
    });
    hammertime.get('swipe').set({ direction: hammer_default.a.DIRECTION_ALL });
    hammertime.get("pinch").set({ enable: true });
    hammertime.add(new hammer_default.a.Tap({ event: "doubletap", taps: 2 }));
    hammertime.add(new hammer_default.a.Tap({ event: "singletap" }));
    hammertime.get("doubletap").recognizeWith("singletap");
    hammertime.get("singletap").requireFailure("doubletap");

    hammertime.on("singletap", function (e) {
      if ((e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1) && Publish.zoomEnabled) {
        mouse.lastX = e.srcEvent.clientX;
        mouse.lastY = e.srcEvent.clientY;
      }
    });

    hammertime.on("doubletap", function (e) {
      if ((e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1)) && Publish.zoomEnabled) {
        Publish.toggleZoom({
          zoomOriginX: e.srcEvent.clientX,
          zoomOriginY: e.srcEvent.clientY
        });
      }
    });

    hammertime.on("pinchin", function (e) {
      Publish.pinchZoom({
        zoomOriginX: e.center.x,
        zoomOriginY: e.center.y,
        zoomLevel: e.scale
      });
    });

    hammertime.on("pinchout", function (e) {
      Publish.pinchZoom({
        zoomOriginX: e.center.x,
        zoomOriginY: e.center.y,
        zoomLevel: e.scale
      });
    });

    hammertime.on("pan", function (e) {
      mouse.x = e.srcEvent.clientX;
      mouse.y = e.srcEvent.clientY;
      mouse.deltaX = mouse.x - mouse.lastX;
      mouse.deltaY = mouse.y - mouse.lastY;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    });

    hammertime.on("panstart", function (e) {
      if (Publish.isZoomed) {
        mouseDown = true;
        mouse.lastX = e.srcEvent.clientX;
        mouse.lastY = e.srcEvent.clientY;
      }
    });

    hammertime.on("panend", function (e) {
      if (mouseDown && Publish.pagesVisible) {
        mouse.lastX = mouse.x;
        mouse.lastX = mouse.y;
        mouseDown = false;
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isGalleryOpen) {
        if (e.direction === hammer_default.a.DIRECTION_LEFT) {
          if (!Publish.rightToLeft) {
            Publish.nextGallerySlide();
          } else {
            Publish.previousGallerySlide();
          }
        } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
          if (!Publish.rightToLeft) {
            Publish.previousGallerySlide();
          } else {
            Publish.nextGallerySlide();
          }
        }
      } else if (Publish.videoURL == "" && !Publish.isZoomed) {
        if (Publish.isMobile) {
          if (Publish.mobileSwitch) {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextMobilePage();
              } else {
                Publish.goToPreviousMobilePage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousMobilePage();
              } else {
                Publish.goToNextMobilePage();
              }
            }
          } else {
            if (!Publish.isZoomed) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextPage();
                } else {
                  Publish.goToPreviousPage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousPage();
                } else {
                  Publish.goToNextPage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            }
          }
        } else {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.goToNextPage();
            } else {
              Publish.goToPreviousPage();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.goToPreviousPage();
            } else {
              Publish.goToNextPage();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_UP) {
            if (Publish.pagesVisible) Publish.goToNextSection();
          } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
            if (Publish.pagesVisible) Publish.goToPreviousSection();
          }
        }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if ((e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1)) && Publish.zoomEnabled) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js

/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute('data-useragent', navigator.userAgent);
    documentElement.setAttribute('data-platform', navigator.platform);
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler() {
    Publish.changeWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-119060941-1',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    this.changeWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "Nf/c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NqUU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q7Iq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UxE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XSu0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gmqq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jsA2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oXGk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uCte":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7bde85d772ba7546503e.js